import React, { useState } from "react";
import styled from "styled-components";
import { PathwayButton } from "./PathwayButtons";
import DatevConnectionButton from "../../_components/DatevConnectionButton";

/**
 * Solid DATEV teal CTA that opens the existing DATEV Buchungsdatenservice connection
 * modal. Reused for every "send to / connect with DATEV" entry point introduced by the
 * DATEV promo work (Buchungsstapel + Shops/Account overview). Uses #0d7676 rather than
 * the mockup's #108F8F button fill — white text on #108F8F only reaches ~3.9:1 contrast,
 * below the 4.5:1 WCAG AA minimum for normal-size text.
 */
const DatevSendButton = ({ children, icon, clients, dataCy, compact }) => {
    const [showModal, setShowModal] = useState(false);

    return (
        <>
            <TealButtonWrapper $compact={compact}>
                <PathwayButton onClick={() => setShowModal(true)} dataCy={dataCy}>
                    {icon}
                    {children}
                </PathwayButton>
            </TealButtonWrapper>

            <HiddenModalHost>
                <DatevConnectionButton clients={clients} isOpen={showModal} onClose={() => setShowModal(false)} />
            </HiddenModalHost>
        </>
    );
};

export default DatevSendButton;

const TealButtonWrapper = styled.div`
    display: inline-block;
    width: max-content;

    & button {
        display: inline-flex;
        align-items: center;
        gap: var(--gap-s);
        white-space: nowrap;
        background-color: #0d7676;
        border-color: #0d7676;
        color: #fff;
        ${(props) =>
            props.$compact && "min-height: 0; line-height: 1.2; padding: 0.2rem 0.6rem; font-size: 0.85rem;"}
    }

    & button:hover,
    & button:focus {
        background-color: #0a5f5f;
        border-color: #0a5f5f;
    }
`;

const HiddenModalHost = styled.div`
    display: none;
`;
